import { HttpRequestState } from "../../shared/http-request-state";

export interface QuoteFeatureState extends HttpRequestState {
  // The applicationId to which this particular quote is connected to.
  // If this value is set, we know that this quote should be considered 'locked'.
  applicationId: string | undefined;
  quoteId: string | undefined;
}

export function createEmptyQuoteFeatureState() {
  const quoteFeatureState: QuoteFeatureState = {
    applicationId: undefined,
    quoteId: undefined,
  };

  return quoteFeatureState;
}
